import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import createRef from '@roo/create-react-ref/createRef';
import TableCell from './TableCell';

var TableRow = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(TableRow, _React$PureComponent);

  var _super = _createSuper(TableRow);

  function TableRow() {
    var _this;

    _classCallCheck(this, TableRow);

    _this = _super.apply(this, arguments);
    _this.ref = createRef();

    _this.handleClick = function (e) {
      var _this$props = _this.props,
          data = _this$props.data,
          onRowClick = _this$props.onRowClick;
      if (onRowClick) onRowClick(data, e);
    };

    _this.handleDoubleClick = function (e) {
      var _this$props2 = _this.props,
          data = _this$props2.data,
          onRowDoubleClick = _this$props2.onRowDoubleClick;
      if (onRowDoubleClick) onRowDoubleClick(data, e);
    };

    _this.handleCellClick = function (columnKey, e) {
      var _this$props3 = _this.props,
          data = _this$props3.data,
          onCellClick = _this$props3.onCellClick;
      if (onCellClick) onCellClick(columnKey, data, e);
    };

    return _this;
  }

  _createClass(TableRow, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.syncHeight();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.syncHeight();
    }
  }, {
    key: "syncHeight",
    value: function syncHeight() {
      var _this$props4 = this.props,
          index = _this$props4.index,
          onSyncHeight = _this$props4.onSyncHeight;
      var height = this.ref.current.offsetHeight; // index 没有与当前行对应，所以需要每次更新 height
      // TODO: 设置一个唯一的 key 与每一行高度绑定

      if (this.ref.current && onSyncHeight) {
        this.lastSyncHeight = height;
        onSyncHeight(index, height);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props5 = this.props,
          data = _this$props5.data,
          columns = _this$props5.columns,
          index = _this$props5.index,
          height = _this$props5.height,
          visible = _this$props5.visible,
          className = _this$props5.className,
          cellClassName = _this$props5.cellClassName;
      return /*#__PURE__*/React.createElement("tr", {
        ref: this.ref,
        onClick: this.handleClick,
        style: {
          height: height,
          display: visible ? '' : 'none'
        },
        className: className,
        onDoubleClick: this.handleDoubleClick
      }, columns.map(function (c, cKey) {
        return /*#__PURE__*/React.createElement(TableCell, {
          index: index,
          key: "".concat(c.prop, "-").concat(index, "-").concat(cKey),
          columnKey: c.prop,
          columnValue: data[c.prop],
          align: c.align,
          render: c.render,
          fullRender: c.fullRender,
          record: data,
          cellClassName: cellClassName,
          onCellClick: _this2.handleCellClick
        });
      }));
    }
  }]);

  return TableRow;
}(React.PureComponent);

export { TableRow as default };